(function () {
  var accordion = document.getElementById("product-feature-accordion");
  if (!accordion) return;

  var items = accordion.querySelectorAll(".product-feature-accordion-item");

  function setOpenHeight(item) {
    var content = item.querySelector(".product-feature-accordion-content");
    if (!content) return;

    if (!item.classList.contains("is-open")) {
      content.style.maxHeight = "0px";
      return;
    }

    content.style.maxHeight = "none";
    var fullHeight = content.scrollHeight;
    content.style.maxHeight = fullHeight + "px";
  }

  function openItem(item) {
    var button = item.querySelector(".product-feature-accordion-button");
    var icon = item.querySelector(".product-feature-accordion-icon");

    item.classList.add("is-open");
    button.setAttribute("aria-expanded", "true");
    icon.textContent = "−";

    setOpenHeight(item);
  }

  function closeItem(item) {
    var button = item.querySelector(".product-feature-accordion-button");
    var icon = item.querySelector(".product-feature-accordion-icon");
    var content = item.querySelector(".product-feature-accordion-content");

    item.classList.remove("is-open");
    button.setAttribute("aria-expanded", "false");
    icon.textContent = "+";
    content.style.maxHeight = "0px";
  }

  function refreshAllHeights() {
    items.forEach(function (item) {
      setOpenHeight(item);
    });
  }

  items.forEach(function (item) {
    var button = item.querySelector(".product-feature-accordion-button");
    if (!button) return;

    if (item.classList.contains("is-open")) {
      openItem(item);
    } else {
      closeItem(item);
    }

    button.addEventListener("click", function () {
      if (item.classList.contains("is-open")) {
        closeItem(item);
      } else {
        openItem(item);
      }
    });
  });

  window.addEventListener("load", function () {
    refreshAllHeights();
    setTimeout(refreshAllHeights, 250);
    setTimeout(refreshAllHeights, 700);
    setTimeout(refreshAllHeights, 1200);
  });

  window.addEventListener("resize", function () {
    refreshAllHeights();
  });

  document.addEventListener("click", function () {
    setTimeout(refreshAllHeights, 150);
    setTimeout(refreshAllHeights, 400);
  });

  if ("ResizeObserver" in window) {
    var ro = new ResizeObserver(function () {
      refreshAllHeights();
    });
    ro.observe(accordion);

    var section = accordion.closest(".product-feature-section");
    if (section) ro.observe(section);
  }

  setTimeout(refreshAllHeights, 200);
  setTimeout(refreshAllHeights, 600);
  setTimeout(refreshAllHeights, 1000);
})();